import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectWorkingDayStartSec } from '@/features/domain/territory'
import { timeWindowUtils } from '@/utils'

import type { TrafficTimeWindows, TrafficTimeWindowsValidation } from '../types'
import { useTexts } from './useTexts'

const defaultTimeWindow: uui.domain.rm.TimeWindow = { startSec: 0, endSec: 0 }

export function useValidateForm() {
  const workingDayStartSec = useSelector(selectWorkingDayStartSec)
  const texts = useTexts()

  return useCallback(
    (formValues: TrafficTimeWindows) => {
      const validation: TrafficTimeWindowsValidation = {}

      const timeWindows = formValues.timeWindows
      const [timeWindow1, timeWindow2] = timeWindows
      const timeWindow1Visible = Boolean(timeWindow1)
      const timeWindow2Visible = Boolean(timeWindow2)

      const normalizedTw1 = timeWindowUtils.normalizeTimeWindow(
        timeWindow1 || defaultTimeWindow,
        workingDayStartSec,
      )
      const normalizedTw2 = timeWindowUtils.normalizeTimeWindow(
        timeWindow2 || defaultTimeWindow,
        workingDayStartSec,
      )

      const isTw1Valid = timeWindowUtils.isTimeWindowValid(normalizedTw1, workingDayStartSec)
      const isTw2Valid = timeWindowUtils.isTimeWindowValid(normalizedTw2, workingDayStartSec)

      if (timeWindow1Visible && timeWindow2Visible) {
        const bothNoEmpty =
          !timeWindowUtils.isTimeWindowEmpty(normalizedTw1) &&
          !timeWindowUtils.isTimeWindowEmpty(normalizedTw2)

        if (bothNoEmpty) {
          if (!isTw1Valid || !isTw2Valid) {
            validation.timeWindows = texts.invalidTimeWindow
          }

          if (isTw1Valid && isTw2Valid) {
            if (timeWindowUtils.areTimeWindowsOverlapping(normalizedTw1, normalizedTw2)) {
              validation.timeWindows = texts.overlappingTimeWindow
            }
          }
        }
      } else {
        if ((!isTw1Valid && timeWindow1Visible) || (!isTw2Valid && timeWindow2Visible)) {
          validation.timeWindows = texts.invalidTimeWindow
        }
      }

      return validation
    },
    [workingDayStartSec, texts],
  )
}
